import type { UseQueryOptions, UseQueryResult } from 'react-query';
import { useQuery } from 'react-query';

import type { IQueryKeyFactory } from '~/helpers/types';
import type { ApiError } from '~/lib/api';
import type { IApiCategoryListResponseBody } from '../CategoriesApi.types';
import { useApi } from '~/lib/api/useApi';

export type IUseCategoriesQueryValues = {
  appId: string;
  parentCategoryId?: string;
};

export const categoriesQueryKeyFactory: IQueryKeyFactory<
  IUseCategoriesQueryValues
> = (values) =>
  values &&
  (['categories', values.appId, values.parentCategoryId ?? null] as const);

export const useCategoriesQuery = (
  values?: IUseCategoriesQueryValues,
  options?: UseQueryOptions<IApiCategoryListResponseBody, ApiError>,
): UseQueryResult<IApiCategoryListResponseBody, ApiError> => {
  const api = useApi();

  return useQuery({
    queryKey: categoriesQueryKeyFactory(values),
    queryFn: values
      ? () =>
          api.categories.getAll(values.appId, {
            parentId: values.parentCategoryId,
          })
      : undefined,
    // TODO once the API is updated to return standard category objects
    // onSuccess: (categories) => {
    //   // For the moment, categories are not paginated and not filtered, so we can just
    //   // set the data for categories queries.
    //   categories.items.forEach((category) =>
    //     queryClient.setQueryData(
    //       categoryQueryKeyFactory({
    //         appId: category.appId,
    //         categoryId: category._id,
    //       }),
    //       category,
    //     ),
    //   );
    //   options?.onSuccess?.(categories);
    // },
    ...options,
  });
};
